import React from 'react';
import './index.css';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import Ingredients from './components/Ingredients';
import OrderSection from './components/OrderSection';
import Footer from './components/Footer';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen">
        <Navbar />
        <main>
          <Hero />
          <ProductSection />
          <Ingredients />
          <OrderSection />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
